import client from './client'

const createTaskFlow = (body) => client.post('/task-flows/create', body)

const getTaskFlow = (flowId) => client.get(`/task-flows/${flowId}`)

const listTaskFlows = (params) => client.get('/task-flows', { params })

const refineTaskFlow = (flowId, body) => client.put(`/task-flows/${flowId}/refine`, body)

const approveTaskFlow = (flowId) => client.post(`/task-flows/${flowId}/approve`)

const convertToTable = (flowId, body) => client.post(`/task-flows/${flowId}/convert-to-table`, body)

const getChatHistory = (flowId) => client.get(`/task-flows/${flowId}/chat-history`)
const getChatHistoryTable = (tableId) => client.get(`/task-flows/table/${tableId}/chat-history`)

const addChatMessage = (flowId, body) => client.post(`/task-flows/${flowId}/chat`, body)

const analyzeTaskFlow = (flowId) => client.get(`/task-flows/${flowId}/analyze`)

const deleteTaskFlow = (flowId) => client.delete(`/task-flows/${flowId}`)

// New two-phase workflow endpoints
const createTaskPlan = (body) => client.post('/task-flows/create-plan', body)

const generateStepsFromPlan = (body) => client.post('/task-flows/generate-steps', body)

const modifyTaskPlan = (body) => client.put('/task-flows/modify-plan', body)

// Planning session management
const getPlanningSession = (sessionId, params) => client.get(`/task-flows/planning-session/${sessionId}`, { params })

const addPlanningMessage = (sessionId, body) => client.post(`/task-flows/planning-session/${sessionId}/message`, body)

export default {
    getChatHistoryTable,
    createTaskFlow,
    getTaskFlow,
    listTaskFlows,
    refineTaskFlow,
    approveTaskFlow,
    convertToTable,
    getChatHistory,
    addChatMessage,
    analyzeTaskFlow,
    deleteTaskFlow,
    // New endpoints
    createTaskPlan,
    generateStepsFromPlan,
    modifyTaskPlan,
    getPlanningSession,
    addPlanningMessage
}
